import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCart, X } from 'lucide-react';
const notifications = [{
  name: 'Sofía',
  location: 'La Plata',
  time: 'hace 3 minutos'
}, {
  name: 'Gabriela',
  location: 'Tucumán',
  time: 'hace 7 minutos'
}, {
  name: 'Andrea',
  location: 'Mar del Plata',
  time: 'hace 12 minutos'
}, {
  name: 'Florencia',
  location: 'Salta',
  time: 'hace 18 minutos'
}, {
  name: 'Daniela',
  location: 'San Juan',
  time: 'hace 25 minutos'
}, {
  name: 'Romina',
  location: 'Neuquén',
  time: 'hace 31 minutos'
}, {
  name: 'Natalia',
  location: 'Bahía Blanca',
  time: 'hace 45 minutos'
}, {
  name: 'Cecilia',
  location: 'Santa Fe',
  time: 'hace 1 hora'
}];
export function PurchaseNotifications() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (isDismissed) return;
    // Initial delay before first notification
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, [isDismissed]);
  useEffect(() => {
    if (isDismissed || !isVisible) return;
    // Hide notification after 4 seconds
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
      // Schedule next notification after 8-12 seconds
      const nextDelay = Math.floor(Math.random() * 4000) + 8000;
      setTimeout(() => {
        if (!isDismissed) {
          setCurrentIndex(prev => (prev + 1) % notifications.length);
          setIsVisible(true);
        }
      }, nextDelay);
    }, 4000);
    return () => clearTimeout(hideTimer);
  }, [isVisible, isDismissed]);
  if (isDismissed) return null;
  const currentNotification = notifications[currentIndex];
  return <div className="fixed bottom-4 left-4 z-50 pointer-events-none" data-id="element-212">
      <AnimatePresence data-id="element-213">
        {isVisible && <motion.div initial={{
        opacity: 0,
        y: 50,
        x: -20
      }} animate={{
        opacity: 1,
        y: 0,
        x: 0
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.9
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 25
      }} className="bg-white rounded-xl shadow-lg border border-maternal-beige p-3 md:p-4 max-w-xs flex items-start gap-3 pointer-events-auto relative" data-id="element-214">
            <button onClick={() => setIsDismissed(true)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition-colors" aria-label="Cerrar notificación" data-id="element-215">
              <X className="w-3 h-3" data-id="element-216" />
            </button>

            <div className="bg-green-100 p-2 rounded-full flex-shrink-0 mt-1" data-id="element-217">
              <ShoppingCart className="w-4 h-4 text-green-600" data-id="element-218" />
            </div>

            <div className="pr-4" data-id="element-219">
              <p className="text-sm text-maternal-brown font-medium leading-tight mb-1" data-id="element-220">
                <span className="font-bold" data-id="element-221">{currentNotification.name}</span> de{' '}
                {currentNotification.location} acaba de comprar
              </p>
              <p className="text-xs text-maternal-lightBrown/70" data-id="element-222">
                {currentNotification.time}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}